module.exports = __webpack_public_path__ + "img/Illustration-03.a6a6759d.png";